export function priceMask(price) {
  let formattedPrice = price;

  formattedPrice = formattedPrice.replace(/\D/g, '');
  formattedPrice = formattedPrice.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

  return formattedPrice;
}
